window.toggleNav = function() {
    document.getElementById('js-nav').classList.toggle('hidden');
    [].forEach.call(document.getElementsByClassName('js-nav-icon'), function(icon) {
        icon.classList.toggle('hidden');
    });
}

document.addEventListener("DOMContentLoaded", function () {
//make menu tabable
        var linksinMenu = document.querySelectorAll('#js-nav > div > a')
        for (var i = 0; i < linksinMenu.length; i++) {
            linksinMenu[i].addEventListener('focusin', (event) => {
            //find subnav
            var nav = event.target.nextElementSibling;
            nav.style.display = 'block';
            //find last link element of subnav
            var lastLink = nav.lastElementChild.lastElementChild;
            lastLink.addEventListener('focusout', (event) => {
                nav.style.removeProperty('display');
            });
        });
    }
});